import {
  P_NOT,
  P_ENC,
  P_PAY,
  P_DET,
  P_CAU,
  P_VRF,
  P_FOU,
  P_MAJ,
  P_EXP,
  P_EXPVRF,
} from '@lba-dev/package.local-globals/paidStatus';
import {
  SAV_CLOT,
  SAV_REAL,
  SAV_REF
} from '@lba-dev/package.local-globals/SAVStatus';
import { I_VRF } from '@lba-dev/package.local-globals/iStatus';

export default collection => ({
  listInterventionApayer: collection === 'interventions'
    ? ({
      title: 'Liste intervention à payer',
      paidStatus: [P_ENC, P_CAU, P_VRF, P_MAJ, P_EXP, P_EXPVRF],
      match: {
        $and: [
          {
            $or: [
              { paid: { $exists: false } },
              { paid: { $nin: [P_PAY, P_DET, P_NOT] } },
            ],
          },
          {
            $or: [
              { isRegle: true },
              {
                $and: [
                  { isRegle: { $ne: true } },
                  { onSitePayment: true },
                  { 'date.ajout': { $gt: new Date(2019, 0, 16) } },
                ],
              },
            ],
          },
        ],
        status: I_VRF,
        artisan: { $exists: true },
      },
    }) : ({
      title: 'SAV Interventions à payer',
      paidStatus: [P_ENC, P_CAU, P_VRF, P_MAJ, P_EXP, P_EXPVRF],
      match: {
        artisan: { $exists: true },
        status: { $in: [SAV_CLOT, SAV_REAL, SAV_REF] },
        $and: [
          {
            $or: [
              { paid: { $exists: false } },
              { paid: { $nin: [P_PAY, P_DET, P_NOT] } },
            ],
          },
          {
            paid: { $ne: P_PAY },
            'infoDescSAV.SAVRemun': true,
            'infoDescSAV.SAVRemunPrice': { $gt: 0 }
          }
        ]

      },
    }),
  relFour: {
    title: 'Relance Fournitures',
    paidStatus: [P_FOU],
    match: {
      $and: [
        {
          $or: [{ paid: P_FOU }, { firstPaid: P_FOU }],
        },
      ],
      artisan: { $exists: true },
    },
  },
});
